module.exports = __webpack_public_path__ + "static/SaolText-Book-27f6847a7cd3c1c4b2355d39fde9504d.woff";